import React from "react";
import LegalPage, { Section, Bullets } from "@/components/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Privacy Policy"
      intro="A short, plain-language summary of what we collect, why, and how you can ask us to remove it."
      updated="February 2026"
    >
      <Section title="Who we are">
        <p>
          Mizizi is an independent digital-cookbook publisher trading as
          Mizizi ("we", "us", "our"). This policy explains how we handle
          personal information on <strong>mizizitable.com</strong>.
        </p>
      </Section>

      <Section title="What we collect">
        <Bullets items={[
          "Your email address, and — when you choose to give it — your name and phone number, so we can send you the book and reply to support requests.",
          "Order details (product, price, currency, timestamps) needed to keep clean bookkeeping.",
          "Basic analytics like which pages are visited most often. We do not build advertising profiles or share this data with third-party ad networks.",
        ]}/>
      </Section>

      <Section title="What we do not collect">
        <Bullets items={[
          "We do not receive, view or store your payment card details — those go directly to Stripe (international) or Paystack (Kenya).",
          "We do not sell or rent your data to any third party.",
        ]}/>
      </Section>

      <Section title="Why we use it">
        <Bullets items={[
          "To deliver the cookbook you purchased.",
          "To reply to customer-support messages.",
          "To send occasional updates about Mizizi — only if you have opted in (the free-sampler signup counts as an opt-in). Every email carries a one-click unsubscribe link.",
        ]}/>
      </Section>

      <Section title="Who handles what">
        <Bullets items={[
          "Email delivery — Resend (resend.com).",
          "Payments — Stripe (stripe.com) for USD/card, Paystack (paystack.com) for KES / M-PESA / card.",
          "Hosting — a managed cloud environment provided by our development platform.",
        ]}/>
      </Section>

      <Section title="Your rights">
        <p>
          You can ask us at any time to see, correct, or delete the personal
          information we hold about you. Write to{" "}
          <a href="mailto:hello@mizizitable.com" className="text-mizizi-terracotta underline underline-offset-4 hover:text-mizizi-gold">
            hello@mizizitable.com
          </a>
          {" "}and we'll respond within 1–2 business days.
        </p>
      </Section>

      <Section title="Cookies">
        <p>
          The site uses a small amount of local storage in your browser
          strictly to remember your session in the Reader after sign-in.
          We do not use tracking cookies for advertising.
        </p>
      </Section>
    </LegalPage>
  );
}
